import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export interface OcrSearchResult {
  pageId: string;
  wordRectLeft: number;
  wordRectTop: number;
  wordRectWidth: number;
  wordRectHeight: number;
  text: string;
  similarity: number;
}

export interface SearchQuery {
  searchString: string;
  similarityThreshold: number;
}

export type DocumentSearchQuery = SearchQuery & { documentIds: string[] };

export interface DocumentSearcher {
  searchText(query: DocumentSearchQuery): Observable<OcrSearchResult[]>;
}

export const DOCUMENT_SEARCHER_TOKEN = new InjectionToken<DocumentSearcher>('DocumentSearcher');
